import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {themeRP} from "@pg-design/themes-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {ErrorSection} from "../components/ErrorSection";

const img404Mobile = require("../images/404_mobile.png");
const img404Desktop = require("../images/404_desktop.png");

export const GoneView = () => {
    return (
        <ErrorSection
            header="Ta strona została usunięta"
            subheader="Adres z wieloma filtrami nie jest już dostępny. Wybierz lokalizację i zawęź wyniki wyszukiwania od nowa."
            infoGraphic={{
                alt: "410",
                sources: [
                    {minWidthPX: 0, width: 336, height: 306, src: img404Mobile},
                    {minWidthPX: themeRP.breakpoints.numeric.md, width: 383, height: 346, src: img404Desktop}
                ]
            }}
        >
            <Button className={buttonStyle} fullWidth variant="filled_primary" href={rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"})}>
                Poszukaj ofert
            </Button>

            <Button className={buttonStyle} fullWidth variant="outlined_secondary" href={rpAppLink.base()}>
                Strona główna
            </Button>
        </ErrorSection>
    );
};

const buttonStyle = css({
    width: "20rem",
    maxWidth: "20rem"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {themeRP} from "@pg-design/themes-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {ErrorSection} from "../components/ErrorSection";

const img404Mobile = require("../images/404_mobile.png");
const img404Desktop = require("../images/404_desktop.png");

export const GoneView = () => {
    return (
        <ErrorSection
            header="Ta strona została usunięta"
            subheader="Adres z wieloma filtrami nie jest już dostępny. Wybierz lokalizację i zawęź wyniki wyszukiwania od nowa."
            infoGraphic={{
                alt: "410",
                sources: [
                    {minWidthPX: 0, width: 336, height: 306, src: img404Mobile},
                    {minWidthPX: themeRP.breakpoints.numeric.md, width: 383, height: 346, src: img404Desktop}
                ]
            }}
        >
            <Button className={buttonStyle} fullWidth variant="filled_primary" href={rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"})}>
                Poszukaj ofert
            </Button>

            <Button className={buttonStyle} fullWidth variant="outlined_secondary" href={rpAppLink.base()}>
                Strona główna
            </Button>
        </ErrorSection>
    );
};

const buttonStyle = css({
    width: "20rem",
    maxWidth: "20rem"
});
